// Pure data shaping for the single-location Meta "story first" layout.
export const META_BENCHMARK_CTR = 0.9;

const isMeta = (p) => p === "facebook" || p === "meta";

export const metaHeadline = (metaSummary, fbAds, facebookCampaign) => {
  const o = metaSummary?.overview || {};
  if (o.total_impressions > 0) {
    return { impressions: o.total_impressions, clicks: o.total_clicks || 0, ctr: parseFloat(o.ctr) || 0 };
  }
  const fc = facebookCampaign?.overview || {};
  if (fc.impressions > 0) {
    return { impressions: fc.impressions, clicks: fc.clicks || 0, ctr: fc.impressions > 0 ? Number(((fc.clicks / fc.impressions) * 100).toFixed(2)) : 0 };
  }
  const impressions = fbAds.reduce((s, a) => s + (a.impressions || 0), 0);
  const clicks = fbAds.reduce((s, a) => s + (a.link_clicks || a.clicks || 0), 0);
  return { impressions, clicks, ctr: impressions > 0 ? Number(((clicks / impressions) * 100).toFixed(2)) : 0 };
};

export const metaDevices = (deviceMetrics = []) => {
  const totals = {};
  deviceMetrics.filter((d) => isMeta(d.platform)).forEach((d) => {
    const k = d.device || "Unknown";
    if (!totals[k]) totals[k] = { device: k, impressions: 0 };
    totals[k].impressions += d.impressions || 0;
  });
  return ["Mobile", "Tablet", "Desktop"].map((k) => totals[k]).filter(Boolean);
};

export const metaVisits = (facebookCampaign) => {
  const out = { view: 0, click: 0, viewRows: [] };
  const byName = {};
  (facebookCampaign?.campaigns || []).forEach((c) => {
    out.view += c.view_through_conversions || 0;
    out.click += c.click_conversions || 0;
    (c.conversion_details?.view_through_conversions || []).forEach((x) => {
      const k = x.name || "Website visit";
      byName[k] = (byName[k] || 0) + (x.count || 0);
    });
  });
  out.viewRows = Object.entries(byName).map(([name, count]) => ({ name, count })).sort((a, b) => b.count - a.count);
  return out;
};

export const metaAudienceItems = (facebookCampaign, metaSummary) => {
  const items = (facebookCampaign?.campaigns || []).flatMap((c) => c.line_items || []);
  return items.length ? items : (metaSummary?.campaigns || []).map((c) => ({ name: c.strategy || c.campaign_name, impressions: c.impressions, clicks: c.clicks }));
};

export const metaAdList = (facebookCampaign, fbAds) => {
  const raw = (facebookCampaign?.campaigns || []).flatMap((c) => c.creatives || []);
  return raw.length ? raw : fbAds.map((a) => ({ name: a.ad_name, impressions: a.impressions, clicks: a.link_clicks || a.clicks || 0 }));
};

export const metaPlacementRows = (metaSummary) => {
  const agg = {};
  for (const p of metaSummary?.placements || []) {
    const name = (p.placement || "Other").trim();
    agg[name] = agg[name] || { placement: name, impressions: 0, clicks: 0 };
    agg[name].impressions += p.impressions || 0;
    agg[name].clicks += p.clicks || 0;
  }
  const list = Object.values(agg).filter((p) => p.impressions > 0).sort((a, b) => b.impressions - a.impressions).slice(0, 6);
  const total = list.reduce((s, p) => s + p.impressions, 0);
  const withCtr = list.map((p) => ({ ...p, ctr: ((p.clicks || 0) / p.impressions) * 100 }));
  const best = Math.max(...withCtr.map((p) => p.ctr), 0);
  return withCtr.map((p) => ({
    label: p.placement, pct: (p.impressions / total) * 100,
    right: `${((p.impressions / total) * 100).toFixed(0)}% of views · ${p.ctr.toFixed(2)}% click rate`, highlight: withCtr.length > 1 && best > 0 && p.ctr === best,
  }));
};
